<main id="main-content" class="container">
	<slot />
</main>

<style lang="postcss">
	@reference "../../app.css";

	.container {
		@apply max-w-2xl mx-auto py-8 px-6;
	}
</style>
